import React from 'react';
import styles from "./JobShiftPreStartView.module.css";

export default function JobShiftPreStartViewHeader({ sections, preStartData, rightClassName = "" }) {

  const projectSection = sections.document_project_details || {};
  const projectDetails = projectSection.data || {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const orgLetter = orgName ? orgName.charAt(0) : "";
  const swmsNumber = projectDetails.swms_number || "";
  const preStartNumber = swmsNumber ? `${swmsNumber}-PSC` : "";
  const swmsVersion = projectDetails.swms_version;
  const revNumber = (swmsVersion && swmsVersion.slice(1)) || "1";
  const shiftId = preStartData && preStartData.shift_id ? preStartData.shift_id : "";

  return (
    <div className={styles.PreviewDocBand} id="prv-doc-band" style={{ borderBottom: "4px solid #f0a14a" }}>
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgLetter}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub} style={{ color: "#f8d9ae", fontWeight: 600 }}>SWMS Pre-Start Checklist</div>
        </div>
      </div>
      <div className={`${styles.PreviewDocBandRight}${rightClassName ? ` ${rightClassName}` : ""}`} style={{ textAlign: "right" }}>
        <div className={styles.PreviewDocBandNo}>
          <span
            style={{
              display: "inline-block",
              verticalAlign: "2px",
              background: "#F0A14A",
              color: "#1F1031",
              fontSize: "10px",
              fontWeight: 800,
              letterSpacing: "0.8px",
              padding: "3px 9px",
              borderRadius: "999px",
              marginRight: "9px",
              lineHeight: 1
            }}
          >
            PSC
          </span>
          {preStartNumber}
        </div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Rev {revNumber} &middot; Shift {shiftId} &middot; {swmsNumber}</div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  )
}